export const getErrorMessage = (statusCode) => {
    switch (statusCode) {
        case 404:
            return 'Resource not found. Please check the URL and try again.'
        case 409:
            return 'The Data has been modified by another process. Please refresh the page.'
        case 401:
            return 'Unauthorised access. Please login and try again.'
        case 408:
            return 'Request timed out. Please try again later.'
        case 400: 
            return 'Bad request. Please check your input and try again.'    
        default:
            return 'An unexpected error occurred. Please try again later.'
    }
}
